import React, { useEffect, useState } from 'react';
import Calling from '../api/Calling';

const LoadChecker = ({ isMobile = false }) => {
    const [loadData, setLoadData] = useState({});

    useEffect(() => {
        // Fetching load data, assuming the backend API is already set up
        const fetchData = async () => {
            try {
                const resp = await Calling.GetServerLoadCheck();  // Adjust the API endpoint as needed
                setLoadData(resp);
            } catch (error) {
                console.error('Error fetching load data:', error);
            }
        };

        fetchData();
        const intervalId = setInterval(fetchData, 2000); // Fetch every 2 seconds
        return () => clearInterval(intervalId);
    }, []);

    // Dynamic color based on CPU Load value
    const getLoadColor = (cpuLoad) => {
        if (cpuLoad < 50) return 'text-green-600'; // Low load
        if (cpuLoad >= 50 && cpuLoad <= 80) return 'text-yellow-600'; // Medium load
        return 'text-red-600'; // High load
    };

    const LoadItem = ({ label, value, colorFunc }) => (
        <div className={`flex flex-col items-center ${isMobile ? 'py-1' : 'border-r border-main-border pr-3 last:border-r-0'}`}>
            {value !== null ? (
                <span className={`font-semibold text-sm sm:text-base ${colorFunc(value)}`}>
                    {value}{label !== 'View' && '%'}
                </span>
            ) : (
                <div className="h-2 flex items-center justify-center">
                    <div className="w-4 h-2 border-2 border-gray-300 border-t-main-blue rounded-full animate-spin"></div>
                </div>
            )}
            <span className="text-xs sm:text-sm text-main-subfont">{label}</span>
        </div>
    );
    return (
        <div className={`relative flex ${isMobile ? 'flex-wrap justify-around gap-3 py-2 px-1' : 'items-center gap-3 sm:gap-6 md:gap-10 px-3 py-1'} bg-white rounded-md shadow-sm`}>
            {!isMobile && <div className="absolute top-0 left-0 h-full w-1 rounded-l-md bg-main-blue"></div>}
            <LoadItem label="CPU" value={loadData.cpuLoad} colorFunc={getLoadColor} />
            <LoadItem label="RAM" value={loadData.ramUsage} colorFunc={getLoadColor} />
            <LoadItem label="Storage" value={loadData.storageUsage} colorFunc={getLoadColor} />
        </div>
    );
};

export default LoadChecker;
